import React, { useState, useEffect } from "react";
import SearchBar from "../../common/components/SearchBar";
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import CustomTable from "../../common/table/CustomTable";
import { PatientsAssignedDataFields, PatientsAssignedHeadCells,dashboardPatientsAssignedDataFields,dashboardPatientsAssignedHeadCells } from "./Constants";
import { useGetPatientByScope } from "../../../hooks/AppsReactQueryHooks/useGetPatientByScope";
import { ButtonGroup, Button } from "react-bootstrap";
import PatientSelection from "../../Admin/Dashboard/PatientSelection";
import {Row, Col} from "react-bootstrap";
import TextInput from "../../common/textfield/TextInput";
import SelectFiled from "../../common/textfield/SelectFiled";
import { useFormik } from "formik";
import { searchPatient } from "../api/Patient";
import { patientSelectionFormikObject } from "../../Admin/Dashboard/Constant";
import { DateSelectorWithoutFormik } from "../../common/textfield/DateSelector";
import moment from "moment";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import ClearIcon from '@mui/icons-material/Clear';
import { Tooltip } from "@mui/material";
import { failed } from "../../common/Toastify";
import { getHCNAuthorityList } from "../../api/HCN";
import { getOrganizationSettings } from "../../api/Organization";

function PatientsSearch(props) {
    const { isLoading, isFetching } = useGetPatientByScope({ onSuccess: (data) => { setPatientsAssigned(data) } })
    const [filterData, setFilterData] = useState([]);
    const [searchData, setSearchData]= useState([]);
    // const [btnActive, setBtnActive] = useState('assigned');
    const [btnLoading, setBtnLoading] = useState(false);
    const [page, setPage] = useState(0);
    const navigate = useNavigate();
    const [patientsAssigned, setPatientsAssigned] = useState([]);
    const dashboard = props.dashboard || false;
    const userOrganizationId = useSelector((state) => state?.auth?.user?.organizations?.[0]?.id);
    const organizations = props.organizations;
    const [orgId, setOrgId] = useState(userOrganizationId);
    const [hcnAuthorityList, setHcnAuthorityList] = useState([]);
    const [ecrEnabled, setEcrEnabled] = useState(false);
    
    const handleOrgChange = (event) => {
        let value = event?.target?.value;
        formik.setFieldValue("organization", value);
        setOrgId(value);
     }

    // const handleBtnChange = (val) => {
    //     setBtnActive(val);
    // }

    const handleDateChange = (val) => {
      if(val == null || val === "") { 
          formik.setFieldValue("birthDate", ""); 
      } 
      const momentDate = moment(val, 'MMM-DD-YYYY', true);
      const isValidDate = momentDate.isValid(); 
      
      if(isValidDate){
          formik.setFieldValue("birthDate", moment(val).format("MM-DD-YYYY")?.replace(/-/g,'/')); 
      } else{
          formik.setFieldValue("birthDate", val);
          formik.setFieldError("birthDate", 'Invalid date format'); 
      } 
    };

    const handleClearDate = () => {
        formik.setFieldValue("birthDate", "");
        formik.setFieldError("birthDate", undefined);
        handleDateChange(null);
    };

    const getHCNAuthorityDisplayFromList = (healthCardAuthority) => {
        const matched = hcnAuthorityList?.find((item) => item?.authority === healthCardAuthority);
        // list items are shaped for SelectFiled { name: display, value: authority } plus original fields
        return matched?.display || matched?.name || "-";
    };

    const formik = useFormik({
        initialValues: {
            firstName: "",
            lastName: "",
            birthDate: "",
            healthCardNumber: "",
            hcnAuthority: "",
            organization: ""
        },
        ...patientSelectionFormikObject,
        onSubmit: async (values) => {
          if(!values.firstName && !values.lastName && !values.birthDate && !values.healthCardNumber) {
            //setNoFilterError("There must be a least one search criteria, other than organization.")
            formik.setFieldError("allSearchFieldsEmpty", "There must be a least one search criteria other than organization");
            setBtnLoading(false);
            setSearchData([]);
            return;
          }
          formik.setFieldError("allSearchFieldsEmpty", undefined);
          setBtnLoading(true);
          try {
            const res = await searchPatient({ ...values, org_id: orgId });
            if (res.status === true) {
              // Check for errors in the response
              if (res.errors && Array.isArray(res.errors) && res.errors.length > 0) {
                res.errors.forEach((error) => {
                  const errorMessage = error.source && error.message 
                    ? `${error.source === "ecr" ? "Client Registry" : error.source}: ${error.message}` 
                    : error.message || error.error || "An error occurred";
                  failed(errorMessage);
                });
              }
              const resWithAuthType = (res.result || []).map((patient) => {
                const hcnIdentifier = patient?.identifier?.find((id) => id?.type === "HCN");
                const authoritySystem = hcnIdentifier?.system;
                let authorityType = authoritySystem ? getHCNAuthorityDisplayFromList(authoritySystem) : "-";

                // External-only identifiers: use system as lookup key, but display the mapped name from the already-fetched list.
                if (authorityType === "-" && !hcnIdentifier) {
                  const externalIdentifier = patient?.identifier?.find((id) => id?.source === "EXT");
                  if (externalIdentifier?.system) {
                    authorityType = getHCNAuthorityDisplayFromList(externalIdentifier.system);
                  }
                }

                return {
                  ...patient,
                  authorityType,
                };
              });
              setSearchData(resWithAuthType);
            } else {
              setSearchData([]);
              failed(res.error || res.message || "Search failed");
            }
          } catch (err) {
            setSearchData([]);
            failed(
              err?.response?.data?.message ||
              err?.response?.data?.error ||
              err.message
            );
          } finally {
            setBtnLoading(false);
          }
        },
      });

    const handleFilterData = (data) => {
        setFilterData(data)
    }

    // const handleView = (data) => {
    //     navigate("/app/patients-details", { state: { id: data?.id, name: data?.name[0]?.text, email: data?.telecom.find((element) => element.system == "email").value} })
    // };


    const handlePatientClick = (data) => {
      const patientId = data?.id;

      // If there is no internal patient id, this record is sourced externally only.
      if (!patientId) {
        failed("Patient is sourced externally and does not exist in Florizel yet.");
        return;
      }

      const baseUrl = window.location.origin;
      const url = `${baseUrl}/app/patients-details?patientId=${patientId}`;
      window.open(url, "_blank");
    };

    useEffect(() => {
          getHCNAuthorityList(orgId).then((res) => {
            if (res?.status === true) {
                const sortedAuthorities = (res.data || [])
                    .slice()
                    .sort((a, b) => (a?.display || "").localeCompare(b?.display || ""));

                const allAuthorities = sortedAuthorities.map((item) => ({
                    ...item,
                    value: item?.authority,
                    name: item?.display
                }));

                setHcnAuthorityList(allAuthorities || []);

                const defaultAuthority = sortedAuthorities?.find((item) => item?.isDefault);
                const singleAuthority = allAuthorities?.length === 1 ? allAuthorities[0] : null;

                // When ECR is enabled, auto-select:
                // - the only authority if there is exactly one option, or
                // - the default authority when multiple options exist.
                if (!formik.values.hcnAuthority && ecrEnabled === true) {
                    const authorityToSelect = singleAuthority || defaultAuthority;
                    if (authorityToSelect?.authority) {
                        formik.setFieldValue("hcnAuthority", authorityToSelect.authority);
                    }
                }
            }
        })
    }, [orgId, ecrEnabled])

    useEffect(() => {
      getOrganizationSettings(orgId).then((res) => {
        if (res?.status === true) {
          setEcrEnabled(res?.data?.ecrEnabled)
        }
      })

    }, [orgId])

    const handleAuthorityChange = (e) => {
        formik.setFieldValue("hcnAuthority", e.target.value)
    };

    const handleSearchPatient = (e)=>{
        e.preventDefault();
        setPage(0);
        !btnLoading && formik.handleSubmit();
      }

    const selectedUserAction = ({ action, data }) => {
        switch (action) {
            case "view":
                handlePatientClick(data)
                break;
            default:
                return null;
        }
    };
    
    return (
        <section className={dashboard? "dashboard patient-wrap" : "common-listing"}> 
            {dashboard && <><div style={{display:"flex", justifyContent: "flex-start"}}className="dashSearch">
                 <Row>
                    <Col>
                        <TextInput
                        keyField={"firstName"}
                        label={"First Name"}
                        formik={formik}
                        placeholder={"First Name"}
                        hideRequired={true}
                        />
                    </Col>
                    <Col>
                        <TextInput
                        keyField={"lastName"}
                        label={"Last Name"}
                        formik={formik}
                        placeholder={"Last Name"}
                        hideRequired={true}
                        />
                    </Col>
                    <Col>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <div style={{ flex: 1 }}>
                                <DateSelectorWithoutFormik
                                    formik={formik}
                                    keyField={'birthDate'}
                                    label="DOB"
                                    value={formik.values.birthDate ? moment(formik.values.birthDate).format("YYYY-MM-DD") : null}
                                    handleChange={handleDateChange}
                                    isError={
                                        formik?.touched?.end && formik?.errors?.end
                                        ? formik?.errors?.end
                                        : ""
                                    }
                                    maxDate={moment()}
                                    hideRequired={true}
                                />
                            </div>
                            {formik.values.birthDate && (
                                <Tooltip title="Clear">
                                    <ClearIcon 
                                        style={{ 
                                            color: "#666", 
                                            cursor: "pointer", 
                                            fontSize: "20px",
                                            alignSelf: "center"
                                        }} 
                                        onClick={handleClearDate}
                                    />
                                </Tooltip>
                            )}
                        </div>
                    </Col>
                    {organizations.length >= 1 &&  <Col>
                      <SelectFiled
                        keyField={"organization"}
                        label={"Select Organization"}
                        selectLabel="Select"
                        formik={formik}
                        options={organizations}
                        isLoading={organizations?.length >= 1 ? false : true}
                        readOnly={organizations?.length >= 1 ? false : true}
                        hideRequired={true}
                        onChange={handleOrgChange}
                      />
                    </Col>}
                    <Col>
                        <TextInput
                        keyField={"healthCardNumber"}
                        label={"Patient Identifier"}
                        formik={formik}
                        placeholder={"Patient Identifier"}
                        hideRequired={true}
                        tooltip={"Searches for exact Patient Identifier match.\n\nWarning: Using this field ignores other filters and searches by patient identifier only."}
                        />
                    </Col>
                    {ecrEnabled && hcnAuthorityList?.length > 1 && (
                      <Col>
                          <SelectFiled
                              formik={formik}
                              options={hcnAuthorityList}
                              fieldtype={"TextInput"}
                              keyField={"hcnAuthority"}
                              label={"Identifier Type"}
                              placeholder={"Identifier Type"}
                              hideRequired={true}
                              onChange={handleAuthorityChange}
                              selectDisabledValue={true}
                          />
                      </Col>
                    )}
                    <Col>
                        <button
                            style={{height:"60px", marginTop:"26px", width: "fit-content"}}
                            className="custom-btn"
                            type="button"
                            isLoading={true}
                            onClick={handleSearchPatient}
                        >
                            <SearchOutlinedIcon/> Search
                        </button>
                        {formik.errors.allSearchFieldsEmpty && (
                          <div className="error-text">{formik.errors.allSearchFieldsEmpty}</div>
                        )}
                    </Col>
                </Row>
                </div>
                <CustomTable
                tableData={searchData}
                headCells={dashboardPatientsAssignedHeadCells}
                dataFields={dashboardPatientsAssignedDataFields}
                selectedUserAction={selectedUserAction}
                rowOptions={false}
                rowClick={dashboard}
                loading={btnLoading}
                fetching={isFetching}
                deletingItem={false}
                canView={true}
                canDelete={false}
                rowsPerPage={dashboard? 5 : 10}
                canEdit={false}
                page={page}
                setPage={setPage}
            /></>}
            {!dashboard && <>
                <div className="heading-wrap">
                    <SearchBar page={page} setPage={setPage} list={patientsAssigned} encoded={true} filterData={handleFilterData} />
                </div>
            
                <CustomTable
                    tableData={filterData}
                    headCells={dashboard ? dashboardPatientsAssignedHeadCells : PatientsAssignedHeadCells}
                    dataFields={dashboard ? dashboardPatientsAssignedDataFields : PatientsAssignedDataFields}
                    selectedUserAction={selectedUserAction}
                    rowOptions={false}
                    rowClick={dashboard}
                    loading={isLoading}
                    fetching={isFetching}
                    deletingItem={false}
                    canView={true}
                    canDelete={false}
                    rowsPerPage={dashboard? 5 : 10}
                    canEdit={false}
                    page={page}
                    setPage={setPage}
                />
                </>
            }  
        </section>
    );
}

export default PatientsSearch;